import { FC } from 'react'
import { ArrowDownTrayIcon } from '@heroicons/react/24/outline'

import { AgGridApp, ButtonApp, Spinner } from '@/components'
import { Account } from '@/models/account'
import { SellTreez } from '@/models/sellTreez'

import { useSellTreezIndexes } from '../hooks'
import { exportIndexesToCsv } from '../utils'

interface Props {
  sellTreez?: SellTreez
  columnIndexDefs: {
    field?: string
    headerName: string
    cellRenderer?: (props: { data: Account }) => JSX.Element
  }[]
}

const SellTreezIndexesTabContent: FC<Props> = ({ sellTreez, columnIndexDefs }) => {
  const { indexes, isLoading } = useSellTreezIndexes()

  const handleExportCsv = () => {
    const filename = `${sellTreez?.name ?? 'indexes'}-indexes.csv`
    exportIndexesToCsv(indexes, filename)
  }

  return (
    <div className="flex flex-col gap-6">
      <div className="flex items-center justify-between">
        <div className="text-gray-800 font-medium">Indexes</div>
        <ButtonApp handleClick={handleExportCsv} isDisabled={isLoading || indexes.length === 0}>
          <div className="flex items-center gap-2">
            <ArrowDownTrayIcon className="h-5 w-5" />
            <span>Export CSV</span>
          </div>
        </ButtonApp>
      </div>

      {isLoading ? (
        <Spinner />
      ) : (
        <AgGridApp
          rowData={indexes}
          columnDefs={columnIndexDefs}
          isShowPagination={false}
          isShowFilter={false}
          paginationPageSize={20}
        />
      )}
    </div>
  )
}

export { SellTreezIndexesTabContent }
